import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  EntityKey,
  FinishingToRollingTransfer,
  FinishingToRollingTransferStatus,
} from '@app/models/inventory/finishing-to-rolling-transfer';

import { getSkipperErrorHeader } from '@app/utilities/error-header.util';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class FinishingToRollingTransferProxyService {
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/finishing-to-rolling-transfer';

  private readonly httpClient = inject(HttpClient);

  public getById(id: string): Observable<ApiResponse<FinishingToRollingTransfer>> {
    return this.httpClient.get<ApiResponse<FinishingToRollingTransfer>>(`${this.baseUrl}/${id}`);
  }

  public getByIds(ids: string[]): Observable<ApiResponse<FinishingToRollingTransfer[]>> {
    return this.httpClient.post<ApiResponse<FinishingToRollingTransfer[]>>(`${this.baseUrl}/batch/ids`, ids);
  }

  public getByInitiator(initiator: EntityKey): Observable<ApiResponse<FinishingToRollingTransfer[]>> {
    const headers = getSkipperErrorHeader(true);
    return this.httpClient.post<ApiResponse<FinishingToRollingTransfer[]>>(`${this.baseUrl}/by-initiator`, initiator, { headers });
  }

  public create(finishingRouteReference: string): Observable<ApiResponse<FinishingToRollingTransfer>> {
    return this.httpClient.post<ApiResponse<FinishingToRollingTransfer>>(
      `${this.baseUrl}/finishing-route/${finishingRouteReference}/create`,
      {},
    );
  }

  public updateStatus(id: string, newStatus: FinishingToRollingTransferStatus): Observable<ApiResponse<object>> {
    return this.httpClient.patch<ApiResponse<object>>(`${this.baseUrl}/${id}/status`, { newStatus });
  }

  public delete(id: string): Observable<ApiResponse<object>> {
    return this.httpClient.delete<ApiResponse<object>>(`${this.baseUrl}/${id}`);
  }
}
